import { render, staticRenderFns } from "./Payrol.vue?vue&type=template&id=d00420d0&"
import script from "./Payrol.vue?vue&type=script&lang=js&"
export * from "./Payrol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports